module.exports = __webpack_public_path__ + "img/Pants.bce542d2.gif";